import { VBtn, VMenu, VList, VListItem, VListItemTitle } from "vuetify/lib";
import VPage from "@/vuetify_custom/v-pagination";
import {
  getSellSettlementEsQueryMineApi,
  getSellSettlementEsQueryApi,
  sellSettlementDeleteApi,
  sellSettlementOrderExportItemsApi,
} from "../services";
import SearchBar from "./SearchBar";
import SearchBarFin from "./SearchBarFin";
import VTable from "@/vuetify_custom/v-table/v3";
import UserFlowBase from "@/views/components/flow/user_flow_base_jsx_v1";
import { SettlementOrderStatusMap } from "../constants";
import CreateSettlementOrderModal from "./CreateSettlementOrderModal";
import ConfirmModal from "./ConfirmModal";
import DelModel from "../DelModel";
import { SettlementOrderDisallowDeleteStatusList } from "../constants";
import SetttlementOrderDetailModal from "./SetttlementOrderDetailModal";

export default {
  props: {
    type: {
      type: Number, // 1业务 ,2财务
      default: "1",
    },
  },
  data() {
    const searchParams = {};
    if (this.type === 1) {
      searchParams.search = "";
      searchParams.search_type = "pending";
    } else if (this.type === 2) {
      searchParams.flow_node_id = null;
      searchParams.user_flow_node_status = -1;
      searchParams.search = "";
    }

    return {
      searchParams: searchParams,
      pagination: {
        page: 1,
        per_page: 10,
        total_count: 0,
      },
      list: [],
      loading: false,
    };
  },
  computed: {
    table_fields() {
      return [
        { text: "结算单号", value: "uid", width: 100 },
        { text: "结算单名称", value: "name", width: 200 },
        { text: "分销商", value: "payee_company_name", width: 200 },
        { text: "合同号", value: "contract_code", width: 200 },
        {
          text: "截止结算日期",
          value: "apply_customer_name",
          width: 200,
          render: (_, row) => {
            return (
              <div>
                {row.begin_date}-{row.end_date}
              </div>
            );
          },
        },
        { text: "金额", value: "total_amount" },
        {
          text: "结算单状态",
          value: "status",
          width: 150,
          render: (_, row) => {
            return <div>{SettlementOrderStatusMap[row.status]}</div>;
          },
        },
        {
          text: "流程",
          value: "user_flow",
          fixed: "right",
          width: 200,
          render: (_, row) => {
            return (
              <div>
                <UserFlowBase
                  modelC={row.user_flow}
                  user_flow={row.user_flow}
                  show_handles={true}
                  on={{
                    ["on-change"]: () => {
                      this.search();
                    },
                  }}
                />
              </div>
            );
          },
        },
        {
          text: "操作",
          value: "operations",
          width: 150,
          fixed: "right",
          render: (_, row) => {
            const canEdit =
              row.user_flow.current_user_flow_node.flow_node_name ===
              "业务填写";
            return (
              <div>
                <div>
                  <VMenu
                    offset-y
                    close-on-click={true}
                    scopedSlots={{
                      activator: ({ on, attrs }) => (
                        <VBtn
                          {...attrs}
                          on={on}
                          color="primary"
                          small
                          style="margin: 10px 0;"
                        >
                          操作
                        </VBtn>
                      ),
                    }}
                  >
                    <VList>
                      <VListItem
                        key="detail"
                        on={{
                          click: () => {
                            this.$refs.settlementOrderDetailModal.open(row);
                          },
                        }}
                      >
                        <VListItemTitle>详情</VListItemTitle>
                      </VListItem>
                      {canEdit && (
                        <VListItem
                          key="edit"
                          on={{
                            click: () => {
                              this.$refs.createSettlementOrderModal.edit(row);
                            },
                          }}
                        >
                          <VListItemTitle>编辑</VListItemTitle>
                        </VListItem>
                      )}
                      <VListItem
                        key="exp"
                        on={{
                          click: () => {
                            // this.$refs.createSettlementOrderModal.edit(row);
                            sellSettlementOrderExportItemsApi({
                              id: row.id,
                            });
                          },
                        }}
                      >
                        <VListItemTitle>导出明细</VListItemTitle>
                      </VListItem>
                      {!SettlementOrderDisallowDeleteStatusList.includes(
                        row.status
                      ) && (
                        <VListItem
                          key="detail"
                          on={{
                            click: () => {
                              this.$refs.delModel.open(row.id);
                            },
                          }}
                        >
                          <VListItemTitle>废弃</VListItemTitle>
                        </VListItem>
                      )}
                      {/* 仅财务 */}
                      {this.type === 2 && row.status === "confirmed" && (
                        <VListItem
                          key="confirm"
                          on={{
                            click: () => {
                              this.$refs.confirmModal.open(row.id);
                            },
                          }}
                        >
                          <VListItemTitle>确认收款</VListItemTitle>
                        </VListItem>
                      )}
                    </VList>
                  </VMenu>
                </div>
              </div>
            );
          },
        },
      ];
    },
  },
  mounted() {},
  methods: {
    search() {
      this.loading = true;
      const mixedSearchParams = {
        ...this.searchParams,
        ...this.pagination,
      };
      (this.type === 1
        ? getSellSettlementEsQueryMineApi(mixedSearchParams)
        : getSellSettlementEsQueryApi(mixedSearchParams)
      )
        .then((res) => {
          if (res.list) {
            this.list = res.list;
          } else if (res.contracts) {
            this.list = res.contracts;
          }
          this.pagination.total_count = res.total_count;
        })
        .catch((err) => {
          console.log(err);
          this.$Message.error("获取数据失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    add() {
      console.log("add");
      this.$refs.createSettlementOrderModal.add();
    },
  },
  render() {
    return (
      <div>
        <div class="contract-group-container">
          {this.type === 1 ? (
            <SearchBar
              ref="searchBar"
              on-search={this.search}
              on-add={this.add}
              v-model={this.searchParams}
            />
          ) : (
            <SearchBarFin
              ref="searchBarFin"
              on-search={this.search}
              on-add={this.add}
              v-model={this.searchParams}
            />
          )}
        </div>
        <div class="list-container">
          <VTable
            headers={this.table_fields}
            desserts={this.list}
            loading={this.loading}
          ></VTable>
        </div>
        <div class="pagination-container">
          <VPage
            current={this.pagination.page}
            total={this.pagination.total_count}
            page-size={this.pagination.per_page}
            size-arr={[10, 20, 50]}
            on={{
              changePageSize: (per_page) => {
                this.pagination.per_page = per_page;
                this.pagination.page = 1;
                this.$nextTick(this.search);
              },
              pageChange: (page) => {
                this.pagination.page = page;
                this.$nextTick(this.search);
              },
            }}
          />
        </div>
        <div ref="contain" style="visibility: hidden;"></div>
        <CreateSettlementOrderModal
          ref="createSettlementOrderModal"
          on-success={this.search}
        />
        <ConfirmModal ref="confirmModal" on-success={this.search} />
        <DelModel
          ref="delModel"
          on-success={this.search}
          delApi={sellSettlementDeleteApi}
        />
        <SetttlementOrderDetailModal ref="settlementOrderDetailModal" />
      </div>
    );
  },
};
